.positioning {
    display: inline-block;
    margin-left: 10px;
}

.tooltipColorGreen {
    color: var(--hps-dark-green);
}
.tooltipColorYellow {
    color: var(--hps-yellow);
}
.tooltipColorRed {
    color: var(--hps-red);
}
.tooltipColorWhite {
    color: var(--hps-white);
}
.tooltipColorGray {
    color: var(--hps-gray);
}

.leftAlignedText {
    text-align: left;
}